import { ref, isRef } from "vue";
import type { Ref } from "vue";

/**
 * @function useToggle - composable function to toggle a value,
 * works only for booleans, if other type of values needed useSetter is a better option
 * @param {Ref<boolean> | undefined | boolean} initialValue - a ref value to modify, if not passed the function initializes in false
 * @return the toggler function, and a value, the value can be the same ref as provided
 */
export default function useToggle(
  initialValue: Ref<boolean> | undefined | boolean = false
): {
  toggle: (targetValue?: boolean) => void;
  value: Ref<boolean>;
} {
  /** value to toggle, if obtained as parameter change that, if a new value */
  const value = isRef(initialValue) ? initialValue : ref(initialValue);
  /** function that toggles the flag*/
  const toggle = (targetValue: boolean | undefined = undefined) => {
    if (targetValue == undefined) {
      value.value = !value.value;
    } else {
      value.value = targetValue;
    }
  };

  return { value, toggle };
}
